import { useAuth as useProviderAuth } from "../../provider/nextjs-auth"
import type { AuthContext, SophyOrganization, SophyUser } from "../../shared/types"

function mapUser(user: ReturnType<typeof useProviderAuth>["user"]): SophyUser | null {
  if (!user) return null

  if (!user.authUserId) {
    throw new Error("Auth provider returned a user without authUserId")
  }

  return {
    ...user,
    authUserId: user.authUserId,
  }
}

function mapOrganization(organization: ReturnType<typeof useProviderAuth>["organization"]): SophyOrganization | null {
  if (!organization) return null

  if (!organization.authOrgId) {
    throw new Error("Auth provider returned an organization without authOrgId")
  }

  return {
    ...organization,
    authOrgId: organization.authOrgId,
  }
}

export function useAuth(): AuthContext {
  const auth = useProviderAuth()

  return {
    ...auth,
    user: mapUser(auth.user),
    organization: mapOrganization(auth.organization),
  }
}
